"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLocale = exports.defaultLocale = exports.translations = exports.initializeLocale = void 0;
var react_intl_1 = require("react-intl");
var ar_1 = __importDefault(require("react-intl/locale-data/ar"));
var de_1 = __importDefault(require("react-intl/locale-data/de"));
var en_1 = __importDefault(require("react-intl/locale-data/en"));
var es_1 = __importDefault(require("react-intl/locale-data/es"));
var fr_1 = __importDefault(require("react-intl/locale-data/fr"));
var it_1 = __importDefault(require("react-intl/locale-data/it"));
var nl_1 = __importDefault(require("react-intl/locale-data/nl"));
var pt_1 = __importDefault(require("react-intl/locale-data/pt"));
var ru_1 = __importDefault(require("react-intl/locale-data/ru"));
var uk_1 = __importDefault(require("react-intl/locale-data/uk"));
var ar_json_1 = __importDefault(require("./ar.json"));
var de_json_1 = __importDefault(require("./de.json"));
var en_json_1 = __importDefault(require("./en.json"));
var es_json_1 = __importDefault(require("./es.json"));
var fr_json_1 = __importDefault(require("./fr.json"));
var it_json_1 = __importDefault(require("./it.json"));
var nl_json_1 = __importDefault(require("./nl.json"));
var pt_json_1 = __importDefault(require("./pt.json"));
var ru_json_1 = __importDefault(require("./ru.json"));
var uk_json_1 = __importDefault(require("./uk.json"));
var DEFAULT_LOCALE = 'en';
exports.defaultLocale = DEFAULT_LOCALE;
var STORAGE_KEY = 'bp/channel-web/user-lang';
var translations = { en: en_json_1.default, fr: fr_json_1.default, pt: pt_json_1.default, es: es_json_1.default, ar: ar_json_1.default, ru: ru_json_1.default, uk: uk_json_1.default, de: de_json_1.default, it: it_json_1.default, nl: nl_json_1.default };
exports.translations = translations;
var cleanLanguageCode = function (str) { return str.split('-')[0]; };
var getNavigatorLanguage = function () { return cleanLanguageCode(navigator.language || navigator['userLanguage'] || ''); };
var getStorageLanguage = function () { var _a; return cleanLanguageCode(((_a = window.BP_STORAGE) === null || _a === void 0 ? void 0 : _a.get(STORAGE_KEY)) || ''); };
// Desired precedence
// 1- manual locale = 'browser' : browser lang
// 2- manual locale is supported : manual lang
// 3- storage lang is supported : storage lang
// 4- browser lang is supported : browser lang
// 5- default lang
var getUserLocale = function (manualLocale) {
    if (manualLocale === void 0) { manualLocale = 'browser'; }
    var browserLocale = getNavigatorLanguage();
    if (manualLocale === 'browser' && translations[browserLocale]) {
        return browserLocale;
    }
    manualLocale = cleanLanguageCode(manualLocale);
    if (translations[manualLocale]) {
        return manualLocale;
    }
    var storageLocale = getStorageLanguage();
    if (translations[storageLocale]) {
        return storageLocale;
    }
    return translations[browserLocale] ? browserLocale : DEFAULT_LOCALE;
};
exports.getUserLocale = getUserLocale;
var initializeLocale = function () {
    (0, react_intl_1.addLocaleData)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], en_1.default, true), fr_1.default, true), pt_1.default, true), es_1.default, true), ar_1.default, true), ru_1.default, true), uk_1.default, true), de_1.default, true), it_1.default, true), nl_1.default, true));
};
exports.initializeLocale = initializeLocale;
